import { Observable, map, of, switchMap } from "rxjs";
import { RequestOptions } from "src/app/services/base.service";
import { BookmarksGroup } from "../models/bookmarks-group.model";
import {BookmarksGroupOperator} from "./bookmarks-group.operator";

export class GenericKeyBookmarksGroupOperator extends BookmarksGroupOperator {

	public loadBookmarksGroup(requestOptions?: RequestOptions): Observable<BookmarksGroup> {
		// If BookmarksGroup doesn't exist - then we automatically create it.
		return this.bookmarkService.getGenericKeyBookmarksGroup(this.id, requestOptions).pipe(
			switchMap(
				(bookmarksGroup: BookmarksGroup) => {
					if (!bookmarksGroup || !bookmarksGroup.bookmarksGroupId) {
							return this.bookmarkService.createGenericKeyBookmarksGroup(this.id, this.routeId, requestOptions).pipe(
								map(
									(response: any) => {

										response.bookmarksGroupId = response.item1;
										response.routeId = response.item2;

										return response;
									}
								)
							);
					}

					return of(bookmarksGroup);
				}
			),
		);
	}
}
